/*
 * ---------------------------------------------------------------------
 * SPDX-License-Identifier: LicenseRef-Proprietary
 * Copyright (c) 2026 WALC Inc. Inc. All Rights Reserved.
 *
 * file=app.routes.ts
 *
 * This software is the confidential and proprietary information of WALC Inc.
 * (Confidential Information). You shall not disclose such Confidential Information
 * and shall use it only in accordance with the terms of the license agreement
 * you entered into with WALC Inc.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * <summary>: 画面のルーティングを定義する。入口（/entry）、チャット（/chat）、エラー（/error）を持ち、
 * 定義していないパスはエラー画面へ転送する。
 * ---------------------------------------------------------------------
 */


import { inject } from '@angular/core';
import { Router, Routes } from '@angular/router';
import { authGuard } from './core/guards/auth-guard';
import { entryGuard } from './core/guards/entry-guard';

export const routes: Routes = [
  {
    path: 'entry',
    canActivate: [entryGuard],
    children: [],
  },
  {
    path: 'chat',
    canActivate: [authGuard],
    loadComponent: () => import('./chat/chat').then((m) => m.Chat),
  },
  {
    path: 'error',
    loadComponent: () => import('./error/error').then((m) => m.Error),
  },
  { path: '', redirectTo: 'chat', pathMatch: 'full' },
  // 上記以外のパスはエラー画面へ。
  {
    path: '**',
    redirectTo: () =>
      inject(Router).createUrlTree(['/error'], {
        queryParams: { reason: 'not_found' },
      }),
  },
];
